// @ts-nocheck

import { getMatchId } from './routes/isMatch';

export const getPreviousMatchId = (history?: unknown): number | null => {
  const previousPathname = history?.getPreviousPath();
  const lastActionType = history?.getLastActionType();
  const matchId = previousPathname ? getMatchId(previousPathname) : null;

  return lastActionType === 'POP' ? matchId : null;
};
